import Cookies from 'js-cookie'
const navigationBar = "new-navigation-bar";
const menuBar = "new-menu-bar";
const token = "new-token";
const myUser = "new-my-user";
const navigationId = "new-navigation-id";
const role = "new-role";
const rollback = "up-layout";
const freightTem = "x-freight-template";
//对头部导航栏进行操作
export function setNavigationBar(event){
  return window.localStorage.setItem(navigationBar,event)
}
export function getNavigationBar(){
  return window.localStorage.getItem(navigationBar);
}
export function removeNavigationBar(){
  return window.localStorage.removeItem(navigationBar);
}
//对路由菜单进行操作
export function setMenuBar(event){
  return window.localStorage.setItem(menuBar,event)
}
export function getMenuBar(){
  return window.localStorage.getItem(menuBar);
}
export function removeMenuBar(){
  return window.localStorage.removeItem(menuBar);
}
//对token进行操作
export function setToken(event){
  return Cookies.set(token,event)
}
export function getToken(){
  return Cookies.get(token);
}
export function removeToken(){
  return Cookies.remove(token);
}
//对我的信息进行操作
export function setMyUser(event){
  return window.localStorage.setItem(myUser,event)
}
export function getMyUser(){
  return window.localStorage.getItem(myUser);
}
export function removeMyUser(){
  return window.localStorage.removeItem(myUser);
}
//对导航id进行操作
export function setNavigationId(event){
  return window.localStorage.setItem(navigationId,event)
}
export function getNavigationId(){
  return window.localStorage.getItem(navigationId);
}
export function removeNavigationId(){
  return window.localStorage.removeItem(navigationId);
}
//当前路由的处理
export function setRole(event,callback){
  window.localStorage.setItem(role,event)
  callback && callback(event)
  return;
}
export function getRole(){
  return window.localStorage.getItem(role);
}
export function removeRole(){
  return window.localStorage.removeItem(role);
}
//回退路由
export function setRollback(event){
  return window.localStorage.setItem(rollback,event)
}
export function getRollback(){
  return window.localStorage.getItem(rollback);
}
export function removeRollback(){
  return window.localStorage.removeItem(rollback);
}
//运费模板保存
export function setFreightTem(event){
  return window.localStorage.setItem(freightTem,event)
}
export function getFreightTem(){
  return window.localStorage.getItem(freightTem);
}
export function removeFreightTem(){
  return window.localStorage.removeItem(freightTem);
}


// WEBPACK FOOTER //
// ./src/utile/auth.js